@if (quickLink.isOther() &&
quickLink.dropdownPossition &&
!isPageQuickLink &&
(quickLink.position.w * quickLink.position.h > 5) &&
pageIndexed &&
!isHSMLink &&
!quickLink.isDigiFit()) {
    <div #dropdown
         [ngStyle]="{
     'top.%': quickLink.dropdownPossition.y,
     'left.%': quickLink.dropdownPossition.x,
     'height.%': quickLink.dropdownPossition.h,
     'width.%': quickLink.dropdownPossition.w,
     'z-index': dropdownShown ? quickLink.zIndex + 10 : quickLink.zIndex
      }"
         class="dropdown quicklink-dropdown">
        <button (mouseout)="hoverDropdown(true)"
                (mouseover)="hoverDropdown()"
                [attr.id]="'dropdownMenu' + quickLink.id"
                [disabled]="bookFeatureService.pageLinksDisabled"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                class="btn btn-sm grow dropdown-toggle"
                type="button">
            <img [src]="dropdownIcon |asset">
        </button>
        <div [attr.aria-labelledby]="'dropdownMenu' + quickLink.id"
             [class.dropdown-menu-end]="applicationStateService.currentViewMode.slug === 'scroll' || pageService.isCenterPage(page) ?  quickLink.position.x > 50: pageService.isRightPage(page)"
             [class.dropdown-menu-start]="applicationStateService.currentViewMode.slug === 'scroll' || pageService.isCenterPage(page) ? quickLink.position.x < 50 : pageService.isLeftPage(page)"
             [class.dropdown-menu-top]="applicationStateService.currentViewMode.slug !== 'scroll' &&  quickLink.position.y > 85"
             class="dropdown-menu">
            <ul>
                <li class="quicklink-dropdown-item">
                    <button (click)="openQuicklink($event)">
                        <div><img [src]="'icon-hsm-showlink.png' |asset" alt="Link" height="25px" width="25px"/></div>
                        <div><span>Aufgabe öffnen</span></div>
                    </button>
                </li>
                @if (quickLink.solutionLink && applicationStateService.bookConfig.displaySolutions && !applicationStateService.isOfflineModeEnabled) {
                    <li class="quicklink-dropdown-item">
                        <button (click)="openQuicklink($event, true)" >
                            <div><img [src]="'solution-icon.png' |asset" alt="Link" height="25px" width="25px"/></div>
                            <div><span>Lösungen anzeigen</span></div>
                        </button>
                    </li>
                }
                @if (applicationStateService.bookConfig.quickLinkPrefix && !applicationStateService.isOfflineModeEnabled) {
                    <li class="quicklink-dropdown-item">
                        <button (click)="addHomework()">
                            <div><img [src]="'hsm-icon.png' |asset" alt="Link" height="30px" width="35px"/></div>
                            <div><span>Zum Aufgabenmanager hinzufügen</span></div>
                        </button>
                    </li>
                }
                @if (!applicationStateService.isOfflineModeEnabled) {
                    <li class="quicklink-dropdown-item">
                        <button (click)="updateBookmark()">
                            <div><img
                                    [src]="isActive ? ('icon-lesezeichen-active.png' | asset) : ('icon-lesezeichen-inactive.png' | asset)"
                                    alt="Link" height="30px" width="20px"/></div>
                            <div>
                                <span>{{ isActive ? 'Von meinen Lesezeichen entfernen' : 'Zum meinen Lesezeichen hinzufügen' }}</span>
                            </div>
                        </button>
                    </li>
                }
            </ul>
        </div>
    </div>
}
